import AvailabilityError from '~/constants/availabilityError';
import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';
import useIsReservableVehicle from './useIsReservableVehicle';

export default function useIsVehicleReservedByOther() {
  const { error, isLockedByThisUser = false } = useVehicleAvailability();
  const isReservableVehicle = useIsReservableVehicle();

  return (
    !isLockedByThisUser &&
    error === AvailabilityError.PurchasePending &&
    isReservableVehicle
  );
}
